import axios from "axios";

import { toastError } from "../../../../shared/toastHelper";

// Conditions autosave field by field, so the server's copy is the truth — but
// only once the saves already sent have landed.
const pendingSaves = new Set();

export const trackFilterSave = (save) => {
  const settled = Promise.resolve(save).catch(() => {});
  pendingSaves.add(settled);
  settled.then(() => pendingSaves.delete(settled));
  return save;
};

export const incompleteConditionErrors = (group) => [...new Set([
  ...(group.fan_filters || []).flatMap((fanFilter) => fanFilter.filter_validation_errors || []),
  ...(group.children || []).flatMap(incompleteConditionErrors),
])];

// An incomplete condition is saved but left out of the audience
// (FanFilterGroup#filter_fans), so saving the segment must stop until it is
// finished or removed.
export const ensureConditionsComplete = (teamId, fanFilterGroupId) => {
  if (!fanFilterGroupId) return Promise.resolve(true);

  return Promise.all([...pendingSaves])
    .then(() => axios.get(`/teams/${teamId}/fan_filter_groups/${fanFilterGroupId}`))
    .then(({ data }) => {
      const errors = incompleteConditionErrors(data);
      if (errors.length === 0) return true;

      toastError(`Finish or remove incomplete conditions before saving: ${errors.join(" ")}`);
      return false;
    });
};
